import { message, Layout, Button, Modal, Row, Input, Col } from 'antd'
import {
  ScheduleOutlined,
  ArrowRightOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
  MailOutlined,
} from '@ant-design/icons'
import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import * as constants from '../../constants/constants'

import { ReactComponent as dataSvg } from '../static/image/data.svg'
import { ReactComponent as learnSvg } from '../static/image/learn.svg'
import { ReactComponent as knowSvg } from '../static/image/know.svg'
import Icon from '@ant-design/icons'
import bannerimage from '../static/image/building-trust.png'

import indexStyles from './index.module.less'
import projectStyles from '../project/project.module.less'
import PageFooter from '../common/page-footer/footer'
import TextArea from 'antd/lib/input/TextArea'
import Cookies from 'js-cookie'
import { sendHttpPostRequest } from '../../api/http-request'
import Draggable from 'react-draggable'

const DataIcon = (props: any) => <Icon component={dataSvg} {...props} />
const LearnIcon = (props: any) => <Icon component={learnSvg} {...props} />
const KnowIcon = (props: any) => <Icon component={knowSvg} {...props} />

export interface Props {}

export const Index: React.FC<Props> = () => {
  const history = useHistory()
  const draggleRef = useRef<HTMLDivElement | null>(null)
  const revealElementsRef = useRef<Record<string, HTMLElement | null>>({})

  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [disabled, setDisabled] = useState(true)
  const [applyNumberVisible, setApplyNumberVisible] = useState(false)
  const [applySubmitVisible, setApplySubmitVisible] = useState(false)
  const [applyUserName, setApplyUserName] = useState('')
  const [applyUserPhone, setApplyUserPhone] = useState('')
  const [collegesAndDepartments, setCollegesAndDepartments] = useState('')
  const [applyUserDuties, setApplyUserDuties] = useState('')
  const [studentCount, setStudentCount] = useState('')
  const [applyUserMajor, setApplyUserMajor] = useState('')
  const [applyReason, setApplyReason] = useState('')
  const [isLocalDeploy, setIsLocalDeply] = useState(false)
  const [visibleElements, setVisibleElements] = useState<Record<string, boolean>>({})

  const sampleProjects = [
    {
      id: 1,
      name: 'COVID-19疫情可视化分析与建模项目',
      tag: '数据可视化',
      description:
        '通过实训，学生将进一步夯实Python语言的编程能力，掌握各类型图表的使用场景，理解传染病动力学模型在实际场景中的应用。',
      skills: ['数据采集', '数据清洗', '数据可视化'],
      teachingTime: 20,
      cover: 'media/course_images/1/bgcovid.png',
    },
    {
      id: 2,
      name: '个人信用风险评估项目',
      tag: '机器学习',
      description:
        '本实训项目旨在基于德国信用数据集，运用 Python 编程语言及相关第三方库，构建高效可靠的自动化信用评分模型。通过对数据的深入分析、预处理、特征工程优化以及模型构建与评估，探索机器学习在银行信贷审批中的实际应用。',
      skills: ['逻辑回归', '特征工程', '模型评估'],
      teachingTime: 16,
      cover: 'media/course_images/2/4e4025aa4cbeb862a3aefd7aa01a6700.jpg',
    },
    {
      id: 7,
      name: '电商数据分析项目',
      tag: '数据清洗',
      description:
        '该项目通过电商数据集，锻炼学生使用 Pandas 进行数据清洗、预处理与统计分析的能力，掌握时间序列模型预测业务指标的方法，以及运用可视化工具构建用户画像的全流程实操技能。',
      skills: ['时间序列', '用户标签', '用户画像'],
      teachingTime: 15,
      cover: 'media/course_images/7/867d116fad93705ebd124558dbd7b3c.png',
    },
    {
      id: 63,
      name: '人工智能通识实践',
      tag: '人工智能',
      description:
        '本实训从六个项目出发，了解人工智能领域的基本应用。项目共分为六章，涵盖从基础机器学习到前沿大语言模型的完整知识体系。',
      skills: ['机器学习', '深度学习', '强化学习', '大模型'],
      teachingTime: 30,
      cover: 'media/course_images/63/bbc4b59c08235e02f6228815414c7c03.jpeg',
    },
    {
      id: 20,
      name: '车牌智能检测与识别项目',
      tag: '计算机视觉',
      description:
        '本项目使用Chinese City Parking Dataset 2020（CCPD2020）数据集构建车牌检测与识别模型，覆盖数据处理、目标检测、OCR 与模型训练全流程。',
      skills: ['YOLO模型', 'OCR', 'Pytorch'],
      teachingTime: 24,
      cover: 'media/course_images/20/车牌智能检测与识别项目@2x.png',
    },
    {
      id: 19,
      name: '微博数据舆情分析项目',
      tag: '自然语言处理',
      description:
        '本项目通过微博数据分析，覆盖文本预处理、热点主题识别、情绪分类、情绪追踪与转发网络分析，帮助学生建立完整的NLP与社交媒体分析实战能力。',
      skills: ['文本预处理', '主题分析', '社交网络分析'],
      teachingTime: 20,
      cover: 'media/course_images/19/bg4@2x.png',
    },
  ]

  const whyCards = [
    {
      title: '真实项目与数据',
      description:
        '基于真实行业数据和项目场景，让学生获得与实际工作环境一致的实践体验。',
      IconComponent: DataIcon,
    },
    {
      title: '综合能力培养',
      description:
        '不仅锻炼技术应用能力，还通过项目报告撰写培养学生的数据分析与表达能力。',
      IconComponent: LearnIcon,
    },
    {
      title: '完善知识体系',
      description:
        '覆盖AI全领域的知识体系，从基础到进阶，满足不同层次教学需求。',
      IconComponent: KnowIcon,
    },
  ]

  const projectTags = [
    '数据采集',
    '数据清洗',
    '数据可视化',
    '机器学习',
    '深度学习',
    '计算机视觉',
    '自然语言处理',
    '多模态',
    '人工智能',
  ]

  const partnerLogos = [
    'http://backend.idatacoding.cn/static/college_logos/2022-05-10/%E5%8D%8E%E4%B8%AD%E7%A7%91%E6%8A%80%E5%A4%A7%E5%AD%A6-01.svg',
    'http://backend.idatacoding.cn/static/college_logos/2024-09-20/%E5%8D%97%E6%96%B9%E7%A7%91%E6%8A%80%E5%A4%A7%E5%AD%A6-01.svg',
    'http://backend.idatacoding.cn/static/college_logos/2022-02-16/%E5%B1%B1%E8%A5%BF%E5%A4%A7%E5%AD%A6-01.svg',
    'http://backend.idatacoding.cn/static/college_logos/2022-04-13/%E5%8C%97%E4%BA%AC%E7%A7%91%E6%8A%80%E5%A4%A7%E5%AD%A6-01.svg',
    'http://backend.idatacoding.cn/static/college_logos/2023-07-07/%E5%8C%97%E4%BA%AC%E4%BF%A1%E6%81%AF%E7%A7%91%E6%8A%80%E5%A4%A7%E5%AD%A6.svg',
    'http://backend.idatacoding.cn/static/college_logos/2022-09-29/%E5%A4%A9%E6%B4%A5%E5%B8%88%E8%8C%83%E5%A4%A7%E5%AD%A6-01.svg',
    'http://backend.idatacoding.cn/static/college_logos/2024-12-27/test.png',
    'http://backend.idatacoding.cn/static/college_logos/2022-02-14/%E6%B9%96%E5%8C%97%E6%B0%91%E6%97%8F%E5%A4%A7%E5%AD%A6-01.svg',
    'http://backend.idatacoding.cn/static/college_logos/2022-12-07/%E6%B9%96%E5%8C%97%E7%BB%8F%E6%B5%8E%E5%AD%A6%E9%99%A2-01.svg',
    'http://backend.idatacoding.cn/static/college_logos/2022-02-17/%E9%95%BF%E6%B1%9F%E5%A4%A7%E5%AD%A6-01(2).svg',
    'http://backend.idatacoding.cn/static/college_logos/2024-04-11/%E6%B9%96%E5%8C%97%E5%B7%A5%E4%B8%9A%E5%A4%A7%E5%AD%A6-02.svg',
  ]

  const contactItems = [
    {
      icon: <EnvironmentOutlined />,
      title: '公司地址',
      content: '北京市海淀区知春路6号锦秋国际大厦B座1304',
    },
    {
      icon: <PhoneOutlined />,
      title: '联系电话',
      content: '136-9329-0406',
    },
    {
      icon: <MailOutlined />,
      title: '电子邮箱',
      content: 'cooperation@boyaidata.com',
    },
  ]

  const onStart = (_event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window.document.documentElement
    const targetRect = draggleRef.current?.getBoundingClientRect()
    if (targetRect) {
      setBounds({
        left: -targetRect.left + uiData.x,
        right: clientWidth - (targetRect.right - uiData.x),
        top: -targetRect.top + uiData.y,
        bottom: clientHeight - (targetRect.bottom - uiData.y),
      })
    }
  }

  const registerRevealElement = (key: string) => (node: HTMLElement | null) => {
    revealElementsRef.current[key] = node
  }

  const getRevealClassName = (key: string, ...classNames: string[]) => {
    return [...classNames, indexStyles.revealBlock, visibleElements[key] ? indexStyles.revealVisible : '']
      .filter(Boolean)
      .join(' ')
  }

  const addCollegeCodeApply = () => {
    sendHttpPostRequest(
      'account/api/user_add_college_code_apply',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        apply_user_phone: applyUserPhone,
        colleges_and_departments: collegesAndDepartments,
        apply_user_duties: applyUserDuties,
        student_count: studentCount,
        apply_user_major: applyUserMajor,
        apply_reason: applyReason,
      },
      (response: any) => {
        message.destroy()
        if (response.is_ok) {
          setTimeout(() => {
            setApplySubmitVisible(false)
          }, 2000)
        } else {
          setApplySubmitVisible(false)
          message.error('申请失败，请稍候再试')
        }
      }
    )
  }

  const checkIsLocalDeploy = () => {
    try {
      sendHttpPostRequest('get_is_deploy', {}, (response) => {
        message.destroy()
        if (response.is_ok && response?.deploy_type == 2) {
          setIsLocalDeply(true)
        }
      })
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    checkIsLocalDeploy()
  }, [])

  useEffect(() => {
    const revealEntries = Object.entries(revealElementsRef.current).filter(([, node]) => Boolean(node))

    if (!revealEntries.length) {
      return
    }

    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      setVisibleElements((prev) => {
        const next = { ...prev }
        revealEntries.forEach(([key]) => {
          next[key] = true
        })
        return next
      })
      return
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return
          }

          const revealKey = (entry.target as HTMLElement).dataset.revealKey
          if (revealKey) {
            setVisibleElements((prev) => {
              if (prev[revealKey]) {
                return prev
              }
              return { ...prev, [revealKey]: true }
            })
          }

          observer.unobserve(entry.target)
        })
      },
      {
        threshold: 0.18,
        rootMargin: '0px 0px -10% 0px',
      }
    )

    revealEntries.forEach(([key, node]) => {
      if (node) {
        node.dataset.revealKey = key
        observer.observe(node)
      }
    })

    return () => {
      observer.disconnect()
    }
  }, [])

  const ApplyComp = (
    <div className={indexStyles.applyMainWrapper}>
      <Row gutter={[16, 16]} className={indexStyles.formRow}>
        <Col xs={24} md={12}>
          <div className={indexStyles.formBlock}>
            <div className={indexStyles.inputTitle}>姓名</div>
            <div className={indexStyles.inputWrapper}>
              <Input
                placeholder="请输入您的姓名"
                value={applyUserName}
                onChange={(e: any) => {
                  setApplyUserName(e.target.value)
                }}
              />
            </div>
          </div>
        </Col>

        <Col xs={24} md={12}>
          <div className={indexStyles.formBlock}>
            <div className={indexStyles.inputTitle}>职务</div>
            <div className={indexStyles.inputWrapper}>
              <Input
                placeholder="请输入您的职务或职称"
                value={applyUserDuties}
                onChange={(e: any) => {
                  setApplyUserDuties(e.target.value)
                }}
              />
            </div>
          </div>
        </Col>
      </Row>

      <div className={indexStyles.formBlock}>
        <div className={indexStyles.inputTitle}>学校名称</div>
        <div className={indexStyles.inputWrapper}>
          <Input
            placeholder="所在学校和院系"
            value={collegesAndDepartments}
            onChange={(e: any) => {
              setCollegesAndDepartments(e.target.value)
            }}
          />
        </div>
      </div>

      <div className={indexStyles.formBlock}>
        <div className={indexStyles.inputTitle}>联系电话</div>
        <div className={indexStyles.inputWrapper}>
          <Input
            placeholder="请输入手机号"
            value={applyUserPhone}
            onChange={(e: any) => {
              setApplyUserPhone(e.target.value)
            }}
          />
        </div>
      </div>

      <Row gutter={[16, 16]} className={indexStyles.formRow}>
        <Col xs={24} md={12}>
          <div className={indexStyles.formBlock}>
            <div className={indexStyles.inputTitle}>授课专业</div>
            <div className={indexStyles.inputWrapper}>
              <Input
                placeholder="请输入您的专业名称"
                value={applyUserMajor}
                onChange={(e: any) => {
                  setApplyUserMajor(e.target.value)
                }}
              />
            </div>
          </div>
        </Col>

        <Col xs={24} md={12}>
          <div className={indexStyles.formBlock}>
            <div className={indexStyles.inputTitle}>使用人数</div>
            <div className={indexStyles.inputWrapper}>
              <Input
                placeholder="请输入您同时使用的人数"
                value={studentCount}
                onChange={(e: any) => {
                  setStudentCount(e.target.value)
                }}
              />
            </div>
          </div>
        </Col>
      </Row>

      <div className={indexStyles.formBlock}>
        <div className={indexStyles.inputTitle}>留言</div>
        <div className={indexStyles.inputWrapper}>
          <TextArea
            placeholder="请输入您的需求或疑问"
            rows={3}
            value={applyReason}
            onChange={(e: any) => {
              setApplyReason(e.target.value)
            }}
          />
        </div>
      </div>

      <div>
        <Button
          style={{ width: '100%', height: '48px', fontSize: 16, fontWeight: 500, borderRadius: 8, color: '#fff' }}
          type="primary"
          className={projectStyles.stepsBtn}
          onClick={() => {
            setApplyNumberVisible(false)
            setApplySubmitVisible(true)
            addCollegeCodeApply()
          }}
        >
          提交申请
        </Button>
      </div>
    </div>
  )

  return (
    <Layout className={indexStyles.pageLayout}>
      <div>
        <div className={indexStyles.headerBannerDiv}>
          <div className={indexStyles.heroInner}>
            <Row gutter={[48, 32]} align="middle" className={indexStyles.heroRow}>
              <Col xs={24} lg={12} className={indexStyles.heroCopyCol}>

                <div className={indexStyles.mainTitle}>数智综合项目实训平台</div>
                <div className={indexStyles.mainDesp}>
                  提供企业级数据分析、机器学习、计算机视觉等领域的实训项目，培养学生的AI实践能力和报告撰写软技能。
                </div>
                <div className={indexStyles.mainBtnWrapper}>
                  <span
                    onClick={() => {
                      history.push('/projects')
                    }}
                    className={indexStyles.browseProjBtn}
                  >
                    浏览项目
                  </span>
                  {isLocalDeploy == false && (
                    <span
                      onClick={() => {
                        setApplyNumberVisible(true)
                      }}
                      className={indexStyles.browseRequestBtn}
                    >
                      申请入驻
                    </span>
                  )}
                </div>

                <div className={indexStyles.heroMetricRow}>
                  <div className={indexStyles.heroMetricCard}>
                    <div className={indexStyles.heroMetricValue}>500+</div>
                    <div className={indexStyles.heroMetricLabel}>合作高校</div>
                  </div>
                  <div className={indexStyles.heroMetricCard}>
                    <div className={indexStyles.heroMetricValue}>AI全栈</div>
                    <div className={indexStyles.heroMetricLabel}>覆盖教学方向</div>
                  </div>
                  <div className={indexStyles.heroMetricCard}>
                    <div className={indexStyles.heroMetricValue}>企业级</div>
                    <div className={indexStyles.heroMetricLabel}>真实项目场景</div>
                  </div>
                </div>
              </Col>

              <Col xs={24} lg={12} className={indexStyles.heroVisualCol}>
                <div className={indexStyles.heroImageShell}>
                  <img src={bannerimage} alt="数据实验楼首页主视觉" className={indexStyles.heroImage} />
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <div className={indexStyles.whyIdatacodingWrapper}>
          <div className={indexStyles.whyIdatacodingInnerWrapper}>
            <div
              ref={registerRevealElement('why-header')}
              className={getRevealClassName('why-header', indexStyles.sectionHeader)}
            >
              <div className={indexStyles.sectionTitle}>为什么选择数据实验楼</div>
              <div className={indexStyles.sectionDesp}>我们的平台为高校师生提供全方位的数智实践教学解决方案</div>
            </div>

            <Row gutter={[24, 24]}>
              {whyCards.map((card, index) => {
                const CardIcon = card.IconComponent
                return (
                  <Col xs={24} md={12} xl={8} key={card.title}>
                    <div
                      ref={registerRevealElement(`why-card-${index}`)}
                      className={getRevealClassName(`why-card-${index}`, indexStyles.whyCard)}
                      style={{ transitionDelay: `${index * 90}ms` }}
                    >
                      <div className={indexStyles.whyCardTitle}>
                        <span className={indexStyles.whyCardTitleIcon}>
                          <CardIcon />
                        </span>
                        {card.title}
                      </div>

                      <div className={indexStyles.whyCardDesp}>{card.description}</div>
                    </div>
                  </Col>
                )
              })}
            </Row>

            <div
              ref={registerRevealElement('partner-panel')}
              className={getRevealClassName('partner-panel', indexStyles.partnerPanel)}
              style={{ transitionDelay: '80ms' }}
            >
              <div className={indexStyles.partnerLead}>
                <div className={indexStyles.partnerLeadTitle}>已服务全国500+高校</div>
                <div className={indexStyles.partnerLeadDesp}>
                  我们的平台已入驻全国500余所高校，得到师生的广泛认可，帮助培养了大批具备实践能力的AI人才。
                </div>
              </div>

              <div className={indexStyles.partnerLogoWall}>
                {partnerLogos.map((logoUrl, index) => (
                  <span className={indexStyles.partnerLogoItem} key={`${logoUrl}-${index}`}>
                    <img src={logoUrl} alt="合作高校logo" loading="lazy" />
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className={indexStyles.projectSectionWrapper}>
          <div className={indexStyles.projectSectionInnerWrapper}>
            <div
              ref={registerRevealElement('project-header')}
              className={getRevealClassName('project-header', indexStyles.sectionHeader)}
            >
              <div className={indexStyles.sectionTitle}>实训项目分类</div>
              <div className={indexStyles.sectionDesp}>涵盖AI领域多个方向，满足不同教学需求</div>
            </div>

            <div
              ref={registerRevealElement('project-tags')}
              className={getRevealClassName('project-tags', indexStyles.projectTagTopWrapper)}
              style={{ transitionDelay: '60ms' }}
            >
              {projectTags.map((tag) => (
                <span className={indexStyles.projectTagTop} key={tag}>
                  {tag}
                </span>
              ))}
            </div>

            <Row gutter={[24, 24]}>
              {sampleProjects.map((project, index) => (
                <Col xs={24} md={12} xl={8} key={project.id}>
                  <div
                    ref={registerRevealElement(`project-card-${project.id}`)}
                    className={getRevealClassName(`project-card-${project.id}`, indexStyles.projectCard)}
                    style={{ transitionDelay: `${index * 80}ms` }}
                  >
                    <div className={indexStyles.projectCover}>
                      <img
                        src={constants.BACKEND_API_URL + project.cover}
                        alt={project.name}
                        loading="lazy"
                      />
                      <span className={indexStyles.projectTag}>{project.tag}</span>
                    </div>

                    <div className={indexStyles.projectCardBody}>
                      <div className={indexStyles.projectName}>{project.name}</div>

                      <div className={indexStyles.projectDesp}>{project.description}</div>

                      <div className={indexStyles.projectSkillWrapper}>
                        {project.skills.map((skill, index) => (
                          <span className={indexStyles.projectSkill} key={`${project.id}-${index}`}>
                            {skill}
                          </span>
                        ))}
                      </div>

                      <div className={indexStyles.projectMetaRow}>
                        <div className={indexStyles.projectTeachingTime}>
                          <ScheduleOutlined /> 学时: {project.teachingTime}
                        </div>
                        <span
                          className={indexStyles.projectLookover}
                          onClick={() => {
                            history.push('/project_detail?project_id=' + project.id)
                          }}
                        >
                          查看详情 <ArrowRightOutlined />
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>

            <div className={indexStyles.seeAllProjectWrap}>
              <span
                onClick={() => {
                  history.push('/projects')
                }}
                className={indexStyles.seeAllProjectBtn}
              >
                查看全部项目 <ArrowRightOutlined />
              </span>
            </div>
          </div>
        </div>

        <div className={indexStyles.contactUsSectionWrapper}>
          <div className={indexStyles.contactUsInnerWrapper}>
            <Row gutter={[40, 32]} align="top">
              <Col xs={24} lg={12}>
                <div
                  ref={registerRevealElement('contact-info')}
                  className={getRevealClassName('contact-info', indexStyles.contactInfoPanel)}
                >
                  <div className={indexStyles.contactHeading}>联系我们</div>
                  <div className={indexStyles.contactHeadingDesp}>
                    如果您的高校也想引入数据实验楼平台，或有任何疑问，欢迎联系我们
                  </div>

                  {contactItems.map((item, index) => (
                    <div
                      ref={registerRevealElement(`contact-item-${index}`)}
                      className={getRevealClassName(`contact-item-${index}`, indexStyles.contactItem)}
                      style={{ transitionDelay: `${120 + index * 80}ms` }}
                      key={item.title}
                    >
                      <div className={indexStyles.conntactIconDiv}>{item.icon}</div>
                      <div className={indexStyles.contactCopy}>
                        <div className={indexStyles.conntactTitle}>{item.title}</div>
                        <div className={indexStyles.conntactContent}>{item.content}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>

              <Col xs={24} lg={12}>
                <div
                  ref={registerRevealElement('apply-panel')}
                  className={getRevealClassName('apply-panel', indexStyles.applyWrapper)}
                  style={{ transitionDelay: '120ms' }}
                >
                  <div className={indexStyles.applyTitle}>申请入驻</div>
                  <div className={indexStyles.applySubDesp}>填写以下信息，我们将尽快与您联系</div>
                  {ApplyComp}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      <PageFooter />

      <Modal
        title={
          <div
            style={{ width: '100%', cursor: 'move', color: '#333' }}
            onMouseOver={() => {
              if (disabled) {
                setDisabled(false)
              }
            }}
            onMouseOut={() => {
              setDisabled(true)
            }}
            onFocus={() => {}}
            onBlur={() => {}}
          >
            机构入驻申请表
          </div>
        }
        className={indexStyles.modelWrapper}
        closable={true}
        centered={true}
        open={applyNumberVisible}
        onCancel={() => {
          setApplyNumberVisible(false)
        }}
        footer={[]}
        modalRender={(modal) => (
          <div>
            <Draggable disabled={disabled} bounds={bounds} onStart={(event, uiData) => onStart(event, uiData)}>
              <div ref={draggleRef}>{modal}</div>
            </Draggable>{' '}
          </div>
        )}
      >
        {ApplyComp}
      </Modal>

      <Modal
        title={
          <div
            style={{ width: '100%', cursor: 'move', color: '#333' }}
            onMouseOver={() => {
              if (disabled) {
                setDisabled(false)
              }
            }}
            onMouseOut={() => {
              setDisabled(true)
            }}
            onFocus={() => {}}
            onBlur={() => {}}
          >
            提示
          </div>
        }
        width={350}
        className={projectStyles.whiteModal}
        closable={false}
        centered={true}
        open={applySubmitVisible}
        footer={[]}
        modalRender={(modal) => (
          <div>
            <Draggable disabled={disabled} bounds={bounds} onStart={(event, uiData) => onStart(event, uiData)}>
              <div ref={draggleRef}>{modal}</div>
            </Draggable>{' '}
          </div>
        )}
      >
        <div className={indexStyles.modalNotice}>已成功提交，会有专员与您联系。</div>
      </Modal>
    </Layout>
  )
}

export default Index